import React from 'react';
import { useIntl } from 'react-intl';
import '../../Icon/ImgIcon.esm.js';
import { DangerIcon, SuccessIcon } from '../../Icon/SemanticIcons.esm.js';

function StatusIcon({ status }) {
    const intl = useIntl();
    switch (status) {
        case 'valid':
            return (React.createElement(SuccessIcon, { className: "tw-flex-initial tw-flex-shrink-0", "aria-label": intl.formatMessage({
                    defaultMessage: 'Valid',
                    id: 'uDKMYM',
                    description: 'Indicates that the form is valid'
                }), size: "sm" }));
        case 'error':
            return (React.createElement(DangerIcon, { className: "tw-flex-initial tw-flex-shrink-0", "aria-label": intl.formatMessage({
                    defaultMessage: 'Error',
                    id: 'Wg2zoV',
                    description: 'Indicates that the form has an error'
                }), size: "sm" }));
        case 'pending':
        case undefined:
            return null;
        default: {
            /* istanbul ignore next */
            if (process.env.NODE_ENV === "development") ;
            return null;
        }
    }
}

export { StatusIcon };
//# sourceMappingURL=StatusIcon.esm.js.map
